"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.Header500DefaultProps = exports.Header500 = void 0;
var _header = _interopRequireDefault(require("./components/header-500"));
exports.Header500 = _header["default"];
var _header2 = _interopRequireDefault(require("./components/header-500.props/header-500.defaultProps"));
exports.Header500DefaultProps = _header2["default"];